import PropertyIntake from "@landingClient/pages/PropertyIntake";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/property-intake/")({
  component: PropertyIntake,
});
